import React from "react";
import { FormControl, InputLabel, Paper, ThemeProvider } from "@mui/material";
import theme from "../../mui-theme";
import IconButton from "@mui/material/IconButton";
import { RiSearchLine } from "react-icons/ri";
import InputBase from "@mui/material/InputBase";

type SEInputSearcProps = {
  value: string;
  placeholder?: string;
  onClick: (value?: any) => void;
  onChange: (value?: any) => void;
};

export const SEInputSearch: React.FC<SEInputSearcProps> = ({
  value,
  onClick,
  onChange,
  placeholder = "Digite o que você procura",
}) => {
  return (
    <FormControl fullWidth>
      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ThemeProvider theme={theme}>
          <InputLabel>{"Busca"}</InputLabel>
          <IconButton
            onClick={onClick}
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
          >
            <RiSearchLine size={16} />
          </IconButton>
          <InputBase
            value={value ?? ""}
            onChange={onChange}
            sx={{ ml: 1, flex: 1 }}
            placeholder={placeholder}
            inputProps={{
              "aria-label": "Digite o que você procura",
            }}
          />
        </ThemeProvider>
      </Paper>
    </FormControl>
  );
};

export default SEInputSearch;
